import React, { useCallback } from 'react';
import FormInput from 'components/Input/FormInput';

interface IContentVersionField {
	changeContentVersion: (value: string) => void;
}

const ContentVersionField: React.FC<IContentVersionField> = ({ changeContentVersion }) => {
	// const handleChange = useCallback(
	// 	(e: React.ChangeEvent<HTMLInputElement>) => {
	// 		e.target.maxLength = 10;
	// 		const onlyDigits = e.target.value.replace(/\D/g, '');
	// 		const validValue = onlyDigits.replace(/^(\d{8})(\d)/, '$1-$2');
	// 		changeContentVersion(validValue);
	// 		return validValue;
	// 	},
	// 	[changeContentVersion],
	// );

	return (
		<FormInput
			testId="ContentVersionField"
			name="contentVersion"
			label="contentVersionLabel"
			placeholder="contentVersionPlaceholder"
			// getValueFromEvent={handleChange}
			onChange={changeContentVersion}
		/>
	);
};

export default React.memo(ContentVersionField);
